import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc2e6a96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-clock me-2" }),
  /*#__PURE__*/_createTextVNode("การรายงานผลการดำเนินการ ")
], -1))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "list-group list-group-flush" }
const _hoisted_7 = { class: "list-group-item" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "ข้อมูลเก่าที่สุด:", -1))
const _hoisted_10 = { class: "col text-end" }
const _hoisted_11 = { class: "list-group-item" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "โครงการ:", -1))
const _hoisted_14 = { class: "col text-end" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "list-group-item" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "รายงานเมื่อ:", -1))
const _hoisted_19 = { class: "col text-end" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "list-group list-group-flush" }
const _hoisted_22 = { class: "list-group-item" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "ข้อมูลที่รายงานล่าสุด:", -1))
const _hoisted_25 = { class: "col text-end" }
const _hoisted_26 = { class: "list-group-item" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "โครงการ:", -1))
const _hoisted_29 = { class: "col text-end" }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "list-group-item" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-muted" }, "รายงานเมื่อ:", -1))
const _hoisted_34 = { class: "col text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.result?.oldestProvince ? `จังหวัด${_ctx.result?.oldestProvince}` : '-'), 1)
              ])
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  (_ctx.result?.oldestProjectUrl)
                    ? (_openBlock(), _createBlock(_component_RouterLink, {
                        key: 0,
                        to: _ctx.result?.oldestProjectUrl
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" ดูโครงการ ")
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_15, "-"))
                ])
              ])
            ]),
            _createElementVNode("li", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.result?.oldest ? (_ctx.result.oldest.getFullYear() > 1900 ? _ctx.thaiDate(_ctx.result.oldest) : '-') : '-'), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("ul", _hoisted_21, [
            _createElementVNode("li", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.result?.latestProvince ? `จังหวัด${_ctx.result?.latestProvince}` : '-'), 1)
              ])
            ]),
            _createElementVNode("li", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  (_ctx.result?.latestProjectUrl)
                    ? (_openBlock(), _createBlock(_component_RouterLink, {
                        key: 0,
                        to: _ctx.result?.latestProjectUrl
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" ดูโครงการ ")
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_30, "-"))
                ])
              ])
            ]),
            _createElementVNode("li", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.result?.latest ? (_ctx.result.latest.getFullYear() > 1900 ? _ctx.thaiDate(_ctx.result.latest) : '-') : '-'), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}